import styled from 'styled-components';
import { useState } from 'react';
import {COLORS, THEME_MODES} from "@repo/ui/themeSettings";
import {CURSOR_TYPES} from "@repo/utils/constants";
import {revealAnimationContainer, useExtendedTheme} from "@repo/ui";

const RevealUpContainer = styled(revealAnimationContainer('div', 'menu-bottom-row-settings-reveal-up'))`
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
`

const StyledWrapper = styled.div`
	width: 50px;
	height: 42px;
	display: flex;
	position: relative;
	transform: translate(5px, -3px) scale(0.8);
	z-index: 2;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		transform: translate(5px, -5px);
	}

	@media (min-width: ${({ theme }) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
		margin-bottom: 10px;
    }
	
	span {
		transition: all 0.4s linear;
		transition-delay: 0.1s;

		opacity: 0;

		&.light-mode {
			opacity: 1;
		}

		background-color: black;

		&.sun-ray-1 {
			position: absolute;
			left: 18px;
			top: 2px;
			height: 7px;
			width: 2px;
		}

		&.sun-ray-2 {
			position: absolute;
			left: 3px;
			transform: rotate(45deg);
			top: 8px;
			height: 2px;
			width: 7px;
		}

		&.sun-ray-3 {
			position: absolute;
			left: -1px;
			top: 21px;
			height: 2px;
			width: 7px;
		}

		&.sun-ray-4 {
			position: absolute;
			left: 4px;
			transform: rotate(-45deg);
			bottom: 6px;
			height: 2px;
			width: 7px;
		}

		&.sun-ray-5 {
			position: absolute;
			left: 18px;
			bottom: 1px;
			height: 7px;
			width: 2px;
		}

		&.moon-addon {
			position: absolute;
			right: -4px;
			top: 14px;
			height: 15px;
			width: 30px;
			border-top-left-radius: 110px;
			border-top-right-radius: 110px;
			border: 1px solid ${COLORS.white};
			background-color: unset;
			border-bottom: 0;
			transform: rotate(90deg);
		}

		&.dark-mode {
			opacity: 1;
		}
	}
`;

const Sun = styled.div`
	width: 23px;
	height: 23px;
	border: 1px solid ${({ theme }) => (theme.mode === THEME_MODES.DARK ? COLORS.white : COLORS.black)};
	border-radius: 50%;
	position: absolute;
	left: 8px;
	top: 10px;
`;

const Moon = styled.div`
	width: 23px;
	height: 23px;
	border: 1px solid ${({ theme }) => (theme.mode === THEME_MODES.DARK ? COLORS.white : COLORS.black)};
	border-radius: 50%;
	position: absolute;
	right: 8px;
	top: 10px;
	transition: all 0.4s;
	&::before {
		position: absolute;
		content: '';
		background-color: ${() => COLORS.gold};
		border-radius: 50%;
		width: 15px;
		height: 15px;
		left: 3px;
		top: 3px;
		z-index: -1;
		transition: all 0.2s linear;
	}
	&.light-mode {
		&::before {
			left: -8px;
			top: 3px;
		}
	}

	&.move-right {
		&::before {
			left: 3px;
			top: 3px;
		}
	}

	&.move-left {
		&::before {
			left: -9px;
			top: 3px;
		}
	}
`;

const CenterGap = styled.div`
	width: 10px;
	height: 17px;
	background-color: ${({ theme }) => (theme.mode === THEME_MODES.DARK ? COLORS.black : COLORS.white)};
	z-index: 100;
	border-radius: 50%;
	position: absolute;
	right: 20px;
	top: 13px;
`;

const ThemeSwitcher = () => {
	const mode = useExtendedTheme((state) => state.mode);
	const setTheme = useExtendedTheme((state) => state.setTheme);
	const [isHovered, setIsHovered] = useState(false);
	// State to prevent moon before element to move when we change theme
	const [clicked, setClicked] = useState(false)

	return (
		<RevealUpContainer>
			<StyledWrapper
				data-cursor={CURSOR_TYPES.THEME_CHANGE}
				onClick={(e) => {
					setTheme({ mode: mode === THEME_MODES.DARK ? THEME_MODES.LIGHT : THEME_MODES.DARK })
					setClicked(true)
				}}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => {
					setIsHovered(false)
					setClicked(false)
				}}
			>
				{Array.from({ length: 5 }).map((_, index) => (
					<span
						key={`sun-ray-${index + 1}key`}
						className={`sun-ray-${index + 1} ${mode === THEME_MODES.LIGHT ? 'light-mode' : ''}`}
					/>
				))}
				<Sun />
				<CenterGap />
				<Moon
					className={`${mode === THEME_MODES.LIGHT ? 'light-mode' : ''} ${
						(isHovered && mode === THEME_MODES.LIGHT && !clicked) ? 'move-right' : ''
					} ${(isHovered && mode === THEME_MODES.DARK && !clicked) ? 'move-left' : ''}`}
				/>
				<span className={`moon-addon ${mode === THEME_MODES.DARK ? 'dark-mode' : ''}`} />
			</StyledWrapper>
		</RevealUpContainer>
	);
};
export default ThemeSwitcher;
